import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import { isUserInVerification } from '../../model/User';
import { isUserProfileFilled } from '../../model/UserVerification';
import RouteEnum from '../../RouteEnum';
import Tracking from '../../services/Tracking';
import type { ReduxState } from '../../store';
import Link from '../Link';
import T, { TContext } from '../Translate';

import styles from './welcomeBanner.module.scss';

interface Props {
  className?: string;
}

export default function WelcomeBanner({ className }: Props) {
  const { show, inReview } = useSelector((state: ReduxState) => ({
    show: state.user && (!isUserProfileFilled(state.user) || isUserInVerification(state.user)),
    inReview: state.user && isUserInVerification(state.user),
  }));

  return (
    <div className={cn(styles.container, { show }, className)}>
      <div className={styles.content}>
        <TContext name={inReview ? 'filled' : null}>
          <div className={styles.body}>
            <T as="h4" id="homepage.welcomeBanner.title" />
            <T as="p" className={styles.description} id="homepage.welcomeBanner.text" />
          </div>
        </TContext>
        {!inReview ? (
          <Link
            className={styles.link}
            onClick={() => Tracking.track('HP_COMPLETE_REG_CLICKED')}
            to={RouteEnum.USER_REGISTRATION}
          >
            <T id="homepage.welcomeBanner.fillProfile" />
            <i className="icon icon-arrow-right-circle" />
          </Link>
        ) : null}
      </div>
    </div>
  );
}
